import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener, ChangeDetectionStrategy, Output, EventEmitter} from '@angular/core';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CartComponent } from '../../../views/cart/cart.component';
import { MenuComponent } from 'src/app/views/menu/menu.component';
import { Company, ConnectionService} from '../../services/Connection/connection.service';
import { CacheService } from '../../services/Cache/cache.service';
import { CartService } from '../../services/Cart/cart.service';
import { placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { ScrollService } from '../../services/Scroll/scroll.service';
import { SharedService } from '../../services/shared/shared.service';
import { OrderService } from '../../services/Order/order.service';


@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css'],
})

export class TopMenuComponent implements OnInit, AfterViewInit{
  @ViewChild('input') input!: ElementRef;
  public typeParam!: typeInterface;
  public placeCounter!: placeCounter;
  nameCompany: string = '';
  readOnlyState: boolean = false;
  user!: Cliente
  img!: string;
  company!: Company
  local!: boolean;
  localCounter: boolean = false;
  userConfirmation: boolean = false;
  counterCart: number = 0;
  completeMenu: boolean = false;
  toggleMenu: number = 2; // 1 - Mobile | 2 - Desktop
  openInfoCompany: boolean = false;
  collapseBox: boolean = false;
  filter: string = '';
  imgBackground: string = '';
  backgroundLoad: boolean = false;
  logoLoad: boolean = false;
  timesInfo: any;
  statusCompany: boolean = false;
  textStatusCompany: string = '';
  textNextStatus: string = '';
  scrollTopPosition: any;
  fixed: boolean = false;
  activeInput: boolean = false;
  showRules: boolean = false;

  constructor(
    public scrollService: ScrollService,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private cartService: CartService,
    private orderService: OrderService,
    public sharedService: SharedService
  ){

    this.connection.nameCompany$.subscribe(newNameCompany => {
      this.nameCompany = newNameCompany
    })

    this.cartService.counter$.subscribe(newCount => {
      this.counterCart = newCount;
    });

    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam;
    })

    this.orderService.placeCounter$.subscribe((newPlace) =>{
      this.placeCounter = newPlace;
    })

    this.connection.company$.subscribe((company) =>{
      if(company){
        this.company = company;
        this.imgBackground = this.company.company.background
        this.img = this.company.company.logo;


        this.validStatus();
        this.validTimes();
        this.loadBackgroundImage();
        
      }
    })

    this.sharedService.filter$.subscribe((data) =>{
      this.filter = data;
    })
    
    this.sharedService.activeInput$.subscribe((data) =>{
      this.activeInput = data;
      if(this.activeInput){
        setTimeout(() => {
          this.input.nativeElement.focus()
        }, 100);

      }
    })

    this.connection.user$.subscribe(
      (data) =>{
        if(data){
          this.user = data
          this.userConfirmation = true;
        }

      }
    )

    this.connection.readOnlyState$.subscribe((data) =>{
      this.readOnlyState = data;
    })
  }
  
  ngOnInit(): void {
    if(this.cacheService.getItemLocal('user_key')){
      this.userConfirmation = true;
    }

    if(this.typeParam.type == 1 || this.typeParam.type == 2){
      this.local = true
    }
    else{
      this.local = false
    }

    if(this.typeParam.type == 3){
      this.localCounter = true;
    }
    else{
      this.localCounter = false;
    }


    if(this.company.configs.typeValue == 1){
      this.company.configs.value = this.formatarPorcentagem(this.company.configs.value);
    }
  }

  ngAfterViewInit(){
    this.cartService.getCartItems();
    this.validLayout();
    this.loadBackgroundImage()
  }


  @HostListener('window:resize')
  onResize(){
    this.validLayout();
  }

  @HostListener('window:scroll')
  onScroll(): boolean  {
    this.validDivBar();
    return false;
  }

  //Função de compartilhar o link do cardápio
  share(): void {
    if (navigator.share) {
      navigator.share({
        title: `Acesse o cardapio de ${this.company.company.companyName}`,
        url: `https://pedeaqui.app/${this.nameCompany}`
      }).then(() => {
        console.log('Compartilhado com sucesso!');
      })
      .catch(console.error);
    } 
  }

  //Observa o carregamento do background
  loadBackgroundImage() {
    const img = new Image();
    img.src = this.imgBackground;
  
    img.onload = () => {
      this.backgroundLoad = true;
    };
  
    img.onerror = () => {
      this.backgroundLoad = true;
    };
  }

  //Observa o carregamento da logo
  loadLogo(){
    this.logoLoad = true;
  }

  //#region Pesquisa

    //Change do Input de pesquisa
    changeInput(){
      this.sharedService.updateFilter(this.filter);
    }

    //Limpar o input de pesquisa
    clearFilter(){
      this.filter = '';
      this.sharedService.updateFilter(this.filter);

      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if(window.innerWidth <= 846)
      {
        if(this.scrollTopPosition >= 195)
        {
          this.sharedService.updateActive(true);
        }
        else{
          this.sharedService.updateActive(false);
        }
      }
    }

    //Fecha o input quando está na div header
    closeInput(){
      this.sharedService.updateFilter('');
      this.sharedService.updateActive(false);
    }

  //#endregion

  //#region Valida algumas lógicas

    //Valida o layout se é mobile ou Desktop
    validLayout(){
      if(window.innerWidth < 846){
        this.toggleMenu = 1;
      }
      else{
        this.toggleMenu = 2;
      }

      if(window.innerWidth < 1169){
        this.completeMenu = true
      }
      else{
        this.completeMenu = false;
      }
    }

    //Valida o status da loja e carrega as informações
    validStatus(){
      if(this.company.company.status == 0){
        this.statusCompany = false;
        this.textStatusCompany = 'Loja fechada';
        this.textNextStatus = `Abre as ${this.company.company.today.open.substring(0, 5)}`
      }
      else{
        this.statusCompany = true;
        this.textStatusCompany = 'Loja aberta';
        this.textNextStatus = `Fecha as ${this.company.company.today.close.substring(0, 5)}`
      }
    }

    //Valida se a barra de navegação precisa aparecer
    validDivBar(){
      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if(window.innerWidth <= 846)
      {

        if(this.company.configs.closeScheduling == 1){
          if(this.scrollTopPosition >= 300)
          {
            this.fixed = true
          }
          else if(this.scrollTopPosition <= 300){
            this.fixed = false
          }
        }
        else{
          if(this.scrollTopPosition >= 300)
          {
            this.fixed = true
          }
          else if(this.scrollTopPosition <= 300){
            this.fixed = false
          }
        }
      }
    }

    //Valida os tempos de preparo
    validTimes() {
      const { deliveryFrom, deliveryTo, counterFrom, counterTo } = this.company.company.times;
    
      this.timesInfo = {
        delivery: {
          active: !(deliveryFrom === 0 && deliveryTo === 0),
          label: this.formatTimeRange(deliveryFrom, deliveryTo)
        },
        counter: {
          active: !(counterFrom === 0 && counterTo === 0),
          label: this.formatTimeRange(counterFrom, counterTo)
        }
      };
    }
    
    //Formata o tempo de preparo
    private formatTimeRange(from: number, to: number): string {
      if (!from && !to) return '';
    
      if (from && to) {
        return `${this.formatMinutes(from, 1)} - ${this.formatMinutes(to, 2)}`;
      }
    
      const value = from || to;
      return this.formatMinutes(value, 0);
    }
    
    //Trata os minutos
    private formatMinutes(minutes: number, type: number): string {
      if (!minutes) return '';
    
      if(type == 1){
        if (minutes < 61) return `${minutes}`;
      }
      else {
        if (minutes < 61) return `${minutes} min`;
      }
  
    
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
    
      if (hours && mins) {
        return `${hours}h${mins}min`;
      }
    
      return `${hours}h`;
    }

    formatarPorcentagem(valor: number | string): string {
      const numero = Number(valor.toString().replace(',', '.'));

      if (isNaN(numero)) return '0';

      // Mantém até 2 casas decimais e remove zeros à direita
      return numero
        .toFixed(2)
        .replace(/\.?0+$/, '');
    }

    toggleRules(){
      this.showRules = !this.showRules;
    }



  //#endregion

}
